import script from "./Page5.vue?vue&type=script&setup=true&lang=js"
export * from "./Page5.vue?vue&type=script&setup=true&lang=js"

import "./Page5.vue?vue&type=style&index=0&id=36dcfe70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36dcfe70"]])

export default __exports__